var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.868 0.753479L10.3188 5.27337L14.868 9.79326C14.9503 9.62138 15.0002 9.43136 15.0002 9.22845V1.31829C15.0002 1.11535 14.9503 0.925364 14.868 0.753479Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6815 0H1.31823C1.11529 0 0.925303 0.0498926 0.753418 0.132129L6.56776 5.91718C7.08187 6.43128 7.91788 6.43128 8.43198 5.91718L14.2463 0.132129C14.0744 0.0498926 13.8845 0 13.6815 0Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.132129 0.753479C0.0498926 0.925364 0 1.11535 0 1.31829V9.22845C0 9.43139 0.0498926 9.62141 0.132129 9.79326L4.68132 5.27337L0.132129 0.753479Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69714 5.89484L9.0534 6.53858C8.19679 7.39519 6.80293 7.39519 5.94632 6.53858L5.30261 5.89484L0.753418 10.4147C0.925303 10.497 1.11529 10.5469 1.31823 10.5469H13.6815C13.8845 10.5469 14.0744 10.497 14.2463 10.4147L9.69714 5.89484Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.546ef8c04df06c44a43b6a3e3e8e6fbc.svg";
export { ForwardRef as ReactComponent };